/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressDataDTO } from './address-data-dto';
import { SystemPropertiesDTO } from './system-properties-dto';
import { ContractLogDTO } from './contract-log-dto';
import { TenantGroupEnumDTO } from './tenant-group-enum-dto';
import { TenantTypeEnumDTO } from './tenant-type-enum-dto';


/**
 * Defines a tenant body that groups fiscal entities and is used for billing
 */
export interface InitializationDTO { 
    /**
     * Email for first tenant user to Managment-UI
     */
    email: string;
    /**
     * Firstname for first tenant user to Managment-UI
     */
    firstname: string;
    /**
     * Lastname for first tenant user to Managment-UI
     */
    lastname: string;
    /**
     * Human readable name of tenant organisation
     */
    name: string;
    /**
     * optional description of tenant
     */
    detailedDescription?: string;
    /**
     * Optional default tax number for all related stores as assigned by the German tax authorities
     */
    taxNumber?: string;
    /**
     * Optional default VAT identification number (Umsatzsteuer-Identifikationsnummer) for all related stores
     */
    vatId?: string;
    billingAddress?: AddressDataDTO;
    /**
     * phone number
     */
    phoneNumber?: string;
    /**
     * reserved for future use
     */
    additionalData?: string;
    /**
     * The customer identifier for linking to the billing system
     */
    customerIdentifier: string;
    tenantType?: TenantTypeEnumDTO;
    /**
     * Default roles for the tenant admin when initialized
     */
    userRoles?: Array<string>;
    systemProperties?: SystemPropertiesDTO;
    vendorCode?: string;
    tenantGroup?: TenantGroupEnumDTO;
    fiscalContract?: ContractLogDTO;
    archivingContract?: ContractLogDTO;
    elsterContract?: ContractLogDTO;
}

export class ClsInitializationDTO { 
    /**
     * Email for first tenant user to Managment-UI
     */
    email: string = undefined;
    /**
     * Firstname for first tenant user to Managment-UI
     */
    firstname: string = undefined;
    /**
     * Lastname for first tenant user to Managment-UI
     */
    lastname: string = undefined;
    /**
     * Human readable name of tenant organisation
     */
    name: string = undefined;
    /**
     * optional description of tenant
     */
    detailedDescription?: string = undefined;
    /**
     * Optional default tax number for all related stores as assigned by the German tax authorities
     */
    taxNumber?: string = undefined;
    /**
     * Optional default VAT identification number (Umsatzsteuer-Identifikationsnummer) for all related stores
     */
    vatId?: string = undefined;
    billingAddress?: AddressDataDTO = undefined;
    /**
     * phone number
     */
    phoneNumber?: string = undefined;
    /**
     * reserved for future use
     */
    additionalData?: string = undefined;
    /**
     * The customer identifier for linking to the billing system
     */
    customerIdentifier: string = undefined;
    tenantType?: TenantTypeEnumDTO = undefined;
    /**
     * Default roles for the tenant admin when initialized
     */
    userRoles?: Array<string> = undefined;
    systemProperties?: SystemPropertiesDTO = undefined;
    vendorCode?: string = undefined;
    tenantGroup?: TenantGroupEnumDTO = undefined;
    fiscalContract?: ContractLogDTO = undefined;
    archivingContract?: ContractLogDTO = undefined;
    elsterContract?: ContractLogDTO = undefined;
}



